import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { User } from '@app/shared/models/user.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { UserRepository } from '@app/shared/state/user/user.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-update-tos-modal',
  templateUrl: './update-tos.component.html',
  styleUrls: ['./update-tos.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class UpdateTosModalComponent {
  updateTosModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  logger = inject(LoggerService);
  private userRepo = inject(UserRepository);
  private eventManager = inject(EventManager);

  user: User = this.userRepo.getUser();

  closeModal() {
    this.eventManager.closeModal(new Modal(this.updateTosModalData.id, ModalType.Persisted, this.updateTosModalData));
  }
}
